import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { requestStore } from 'actionCreators';
import Loading from 'components/Loading';
import StoreDetailsCard from './components/storeDetailsCard';
import { getRole, getStoreById, getPricePatchById } from '../../../../reducers';
import { can } from '../../../../services';
import connectUI from 'redux-ui';
import MessageBox from 'components/MessageBox';

class StoreDetails extends React.Component {
  componentDidMount() {
    this.props.requestStore(this.props.id);
  }

  componentWillUnmount() {
    if (this.props.ui.successMessage) {
      this.props.updateUI('successMessage', '');
    }
  }

  render() {
    const { loading, store, canEdit, ui, pricePatch } = this.props;
    return (
      <div>
        {ui.successMessage ? <MessageBox message={ui.successMessage} /> : null}
        {
          loading ?
            <Loading /> :
            <StoreDetailsCard
              canEdit={canEdit}
              store={store}
              pricePatch={pricePatch}
            />
        }
      </div>
    );
  }
}

StoreDetails.propTypes = {
  loading: PropTypes.bool,
  canEdit: PropTypes.bool,
  store: PropTypes.object,
  ui: PropTypes.object,
  updateUI: PropTypes.func,
  id: PropTypes.number,
  requestStore: PropTypes.func,
  pricePatch: PropTypes.object,
};

function mapStateToProps(state, ownProps) {
  const id = Number(ownProps.params.id);
  const store = getStoreById(state)(id);
  const loading = store ? store.loading : true;
  const pricePatch = loading ? null : getPricePatchById(state)(store.price_patch) || {};
  const role = getRole(state); // TODO: Obtain role from parent component
  return {
    id,
    store,
    canEdit: can(role, 'update', 'store'),
    loading,
    pricePatch,
  };
}

const mapDispatchToProps = dispatch => ({
  requestStore: id => dispatch(requestStore(id)),
});

export default connectUI()(connect(mapStateToProps, mapDispatchToProps)(StoreDetails));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/storeDetails.jsx